import { DataItem } from 'scrivito'

export const getSelectableIds = (
  dataItems: DataItem[],
  dataClassName: string | undefined,
) => {
  switch (dataClassName) {
    default:
      return dataItems.map((item) => {
        return item.id()
      })
  }
}
